/* eslint-disable no-console */
import { all, call, put, takeLatest } from 'redux-saga/effects'

import actions from './actions'
import api from './api'

export function* fetchDataFootprint({ payload }) {
  const { callback } = payload
  let isSuccess = false
  try {
    const [dataBuyers, dataSellers, dataBreaches] = yield all([
      call(api.fetchDataBuyers),
      call(api.fetchDataSellers),
      call(api.fetchDataBreaches),
    ])
    yield put(actions.fetchDataFootprint.success(dataBuyers, dataSellers, dataBreaches))
    isSuccess = true
  } catch (err) {
    console.error('[DataFootprint] fetchDataFootprint:', err)
    yield put(actions.fetchDataFootprint.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

export default function* main() {
  yield takeLatest(actions.fetchDataFootprint.INIT_TYPE, fetchDataFootprint)
}
